export const translations = {
  ro: {
    // Banner
    bannerText: "Rezervă-ți prima ședință online cu un terapeut certificat și primești",
    bannerDiscount: "–100 lei",
    bannerCta: "Programează",
    bannerCtaFull: "Programează acum",
    
    // Navigation
    navAbout: "Despre mine",
    navServices: "Servicii",
    navTests: "Teste psihologice",
    navTestsChildren: "Teste pentru copii și adolescenți",
    navTestsAdults: "Teste pentru adulți",
    navBlog: "Blog",
    navBlogArticles: "Articole",
    navBlogResources: "Resurse",
    breadcrumbHome: "Acasă",
    blogEyebrow: "Psihologie și psihoterapie",
    blogIntro:
      "Articole și resurse din psihologie și psihoterapie, create pentru a oferi informații clare, relevante și fundamentate profesional despre sănătatea psihologică, dezvoltare și funcționarea emoțională.",
    blogCardArticlesTitle: "Articole",
    blogCardArticlesDesc:
      "Articole despre psihologie, psihoterapie, sănătate psihologică, dezvoltare, relații, reglare emoțională și alte teme relevante.",
    blogCardArticlesCta: "Vezi articolele",
    blogCardResourcesTitle: "Resurse",
    blogCardResourcesDesc:
      "Materiale și resurse psihologice practice, organizate într-un singur spațiu accesibil.",
    blogCardResourcesCta: "Vezi resursele",
    blogLatestTitle: "Articole recente",
    blogLatestAll: "Vezi toate articolele",
    blogLatestEmpty:
      "Primele articole sunt în pregătire. Vor apărea aici, pe măsură ce sunt publicate.",
    articlesArchiveIntro:
      "Articole despre psihologie, psihoterapie, sănătate psihologică, dezvoltare, relații și reglare emoțională.",
    articlesEmptyTitle: "Primele articole sunt în pregătire",
    articlesEmptyText:
      "Momentan nu există articole publicate. Până atunci, poți explora resursele psihoeducaționale disponibile.",
    articlesEmptyCta: "Vezi resursele",
    articleReadCta: "Citește articolul",
    navContact: "Contact",
    navCta: "Programare",
    navTagline: "Cabinet Individual de Psihologie și Psihoterapie",
    
    // Hero
    heroEyebrow: "Psiholog online · Sprijin psihologic",
    heroTitleL1: "Înțelegerea tiparelor",
    heroTitleL2: "din spatele",
    heroTitleL3: "modului în care",
    heroTitleWords: ["gândim.", "simțim.", "relaționăm.", "reacționăm."],
    heroTitleFull: "Înțelegerea tiparelor din spatele modului în care gândim, simțim, relaționăm și reacționăm.",
    heroSubtitleA: "Psiholog clinician și psihoterapeut integrativ. Ofer consiliere psihologică și psihoterapie, în principal online, pentru ",
    heroSubtitleB: "adulți, adolescenți și copii",
    heroSubtitleC: ", într-un cadru confidențial, cu accent pe ",
    heroSubtitleD: "înțelegerea nevoilor individuale",
    heroSubtitleE: ", întărirea resurselor personale și sprijinirea unor ",
    heroSubtitleF: "moduri mai adaptative de a face față vieții de zi cu zi.",
    heroBullet1: "Sprijin confidențial și individualizat",
    heroBullet2: "Practică psihologică fundamentată pe dovezi",
    heroBullet3: "Orientat spre înțelegere, adaptare și schimbare autentică",
    heroCta: "Programează prima ședință",
    heroSecondary: "Vezi cum te pot ajuta",
    heroTransition: "Nu e nevoie să ai totul clarificat pentru a cere sprijin.",
    heroScroll: "Derulează pentru a explora",
    
    // Validation Section
    validationLabel: "Poate te regăsești aici",
    validationTitle1: "Poate recunoști",
    validationTitle2: "unele dintre aceste situații",
    validationSymptom1: "Multe gânduri",
    validationSymptom2: "Urcușuri și coborâșuri emoționale",
    validationSymptom3: "Dificultăți în relații",
    validationSymptom4: "Senzația de epuizare",
    validationSymptom5: "Dorința de schimbare",
    validationCta: "Vezi cum te pot ajuta",
    validationQuote: '"Terapia nu este doar pentru criză."',
    validationQuoteText: "Mulți oameni vin la terapie nu pentru că ceva este grav în neregulă, ci pentru că își doresc mai multă claritate, echilibru emoțional și un mod mai sănătos de a se raporta la ei înșiși și la ceilalți.",
    validationFooterNote: "Nu trebuie să înțelegi totul singur.",
    perspectiveLabel: "O altă perspectivă",
    perspectiveTitle1: "Terapia nu este",
    perspectiveTitleItalic: "doar",
    perspectiveTitle2: "pentru momentele de criză.",
    perspectiveP1: "Sprijinul psihologic poate fi valoros chiar și atunci când viața pare să funcționeze relativ bine.",
    perspectiveP2a: "Terapia nu trebuie să înceapă doar atunci când dificultățile devin ",
    perspectiveP2b: "copleșitoare",
    perspectiveP2c: "; ea poate fi și o ",
    perspectiveP2d: "modalitate proactivă",
    perspectiveP2e: " de a înțelege îngrijorările care apar, de a ",
    perspectiveP2f: "consolida resursele psihologice",
    perspectiveP2g: " și de a aborda anumite tipare ",
    perspectiveP2h: "înainte ca acestea să devină mai persistente sau perturbatoare",
    perspectiveP3: "Uneori, căutarea sprijinului din timp poate face schimbarea mai clară, mai ușor de gestionat și mai durabilă.",
    perspectiveCta: "Află mai mult despre proces",
    perspectiveAside: "Pașii mici pot duce la schimbări cu sens.",
    
    // Services
    servicesLabel: "Servicii",
    servicesTagline: "Sprijin adaptat nevoilor tale.",
    servicesTitle: "Servicii",
    serviceLearnMore: "Află mai mult",
    serviceBackToServices: "Înapoi la servicii",
    svc1Title: "Psihoterapie online pentru adulți",
    svc1TitleL1: "Psihoterapie online",
    svc1TitleL2: "pentru adulți",
    svc1Meta: "Online / la cabinet · 50 minute",
    svc1Desc: "Proces psihoterapeutic individual destinat adulților care se confruntă cu dificultăți emoționale, relaționale sau personale și își doresc o mai bună înțelegere a propriilor experiențe, reacții și tipare de funcționare, precum și dezvoltarea unor modalități mai adaptative de gestionare a acestora.",
    svc1Cta: "Programează o ședință",
    svc2Title: "Consiliere psihologică pentru copii și adolescenți",
    svc2Meta: "Online / la cabinet · 50 minute",
    svc2Desc: "Sprijin psihologic adaptat nivelului de dezvoltare și nevoilor individuale ale copilului sau adolescentului, orientat spre înțelegerea și gestionarea dificultăților emoționale, relaționale, comportamentale sau de adaptare.",
    svc2Cta: "Programează o ședință",
    svc3Title: "Consiliere în carieră și orientare vocațională",
    svc3Meta: "Adolescenți și tineri · Online / la cabinet · 50 minute",
    svc3Desc: "Proces de explorare și clarificare a intereselor, aptitudinilor, valorilor personale și opțiunilor educaționale sau profesionale, cu scopul de a susține luarea unor decizii informate privind parcursul academic și profesional.",
    svc3Cta: "Programează o ședință",
    svc4Title: "Evaluare psihologică și psihodiagnostic",
    svc4Desc: "Proces de evaluare psihologică adaptat vârstei și nevoilor individuale, care urmărește înțelegerea funcționării cognitive, emoționale, comportamentale și adaptative, precum și identificarea resurselor și a aspectelor care pot necesita intervenție sau sprijin.",
    svc4Cta: "Programează o evaluare",
    assessChildrenTitle: "Evaluare psihologică pentru copii și adolescenți",
    assessAdultsTitle: "Evaluare psihologică pentru adulți",

    assessAdultsIntro: "Evaluarea psihologică pentru adulți este un proces structurat prin care funcționarea emoțională, cognitivă și relațională este explorată cu ajutorul interviului clinic și al unor instrumente psihologice validate. Scopul nu este eticheta, ci o înțelegere clară a ceea ce se întâmplă și a direcțiilor de sprijin potrivite.",
    assessAdultsP2: "Evaluarea se poate desfășura online sau la cabinet și este adaptată întrebării cu care vii: unele situații se clarifică într-o singură întâlnire, altele necesită un set mai amplu de probe, administrate în două sau trei ședințe.",
    assessAdultsAreasTitle: "Ce arii pot fi explorate",
    assessAdultsArea1: "Personalitate și stiluri de funcționare — trăsături stabile, mecanisme de adaptare și modul în care răspunzi la solicitări.",
    assessAdultsArea2: "Funcționare emoțională — reglarea emoțiilor, sensibilitatea la stres, recunoașterea și exprimarea trăirilor.",
    assessAdultsArea3: "Anxietate, dispoziție și stres — intensitatea simptomelor, impactul asupra somnului, concentrării și relațiilor, semnele de epuizare profesională.",
    assessAdultsArea4: "Funcționare cognitivă, atunci când este relevant — atenție, memorie de lucru, ritm de procesare și organizarea sarcinilor.",
    assessAdultsArea5: "Context relațional și ocupațional — dinamici de cuplu, familie sau echipă și adaptarea la mediul de muncă.",
    assessAdultsWhyTitle: "De ce solicită adulții o evaluare psihologică",
    assessAdultsWhy1: "Pentru a înțelege dificultăți care persistă de mai mult timp și nu se clarifică prin discuții informale.",
    assessAdultsWhy2: "Pentru a diferenția între stres situațional, epuizare și dificultăți emoționale care necesită sprijin de specialitate.",
    assessAdultsWhy3: "Pentru a orienta un proces de psihoterapie și a stabili obiective realiste la începutul acestuia.",
    assessAdultsWhy4: "Pentru autocunoaștere, decizii personale sau profesionale și o imagine mai clară asupra resurselor proprii.",
    assessAdultsProcessTitle: "Cum se desfășoară evaluarea",
    assessAdultsProcessText: "Pornim de la un interviu clinic în care clarificăm motivul evaluării, istoricul relevant și contextul actual de viață. Pe baza acestuia sunt selectate instrumentele potrivite — chestionare de personalitate, scale clinice sau probe cognitive — și stabilim împreună numărul de întâlniri necesare. Administrarea și interpretarea respectă standardele profesionale și etice ale practicii psihologice.",
    assessAdultsFeedbackTitle: "Feedback și recomandări",
    assessAdultsFeedbackText: "La final primești o ședință de feedback în care rezultatele sunt explicate într-un limbaj accesibil, fără jargon, împreună cu punctele forte identificate și cu dificultățile care pot necesita sprijin. Recomandările pot include psihoterapie, consiliere psihologică, o reevaluare după o perioadă sau, atunci când este necesar, îndrumarea către un alt specialist. Rezultatele sunt confidențiale și îți sunt comunicate doar ție.",
    assessAdultsNote: "Evaluarea psihologică pentru adulți este un proces profesionist, realizat de psiholog, diferit de testele de screening disponibile gratuit pe acest site, care au doar rol orientativ. Evaluarea clinică și educațională oferită aici nu reprezintă expertiză judiciară sau medico-legală.",

    assessChildrenIntro: "Evaluarea psihologică pentru copii și adolescenți urmărește înțelegerea modului în care copilul funcționează emoțional, cognitiv și comportamental, raportat la vârsta și la etapa sa de dezvoltare. Procesul îmbină discuția cu părinții, observația și instrumente psihologice adaptate vârstei.",
    assessChildrenP2: "Fiecare evaluare pornește de la îngrijorarea concretă a familiei — dificultăți la școală, reacții emoționale intense, probleme de atenție sau de relaționare — și este construită în jurul contextului de viață al copilului.",
    assessChildrenAreasTitle: "Ce arii pot fi explorate",
    assessChildrenArea1: "Funcționare emoțională — anxietate, temeri, tristețe, iritabilitate și capacitatea de a recunoaște și regla emoțiile.",
    assessChildrenArea2: "Atenție și concentrare — menținerea atenției la sarcină, impulsivitate, nivel de activitate și organizare.",
    assessChildrenArea3: "Învățare și motivație școlară — interesul pentru învățare, ritmul de lucru, dificultățile specifice și încrederea în propriile abilități.",
    assessChildrenArea4: "Comportament — opoziționism, conflicte, reacții de furie sau retragere, respectarea limitelor.",
    assessChildrenArea5: "Adaptare școlară și relații — integrarea în colectiv, relația cu profesorii și colegii, tranzițiile precum debutul școlar sau schimbarea școlii.",
    assessChildrenArea6: "Context de dezvoltare — repere de dezvoltare, istoric medical și evenimente semnificative din viața familiei.",
    assessChildrenWhyTitle: "Când este utilă o evaluare",
    assessChildrenWhy1: "Când dificultățile se mențin de mai multe săptămâni și afectează școala, somnul, relațiile sau starea de spirit a copilului.",
    assessChildrenWhy2: "Când părinții sau cadrele didactice observă schimbări importante de comportament ori de randament școlar.",
    assessChildrenWhy3: "Înaintea unor decizii educaționale, precum debutul școlar sau alegerea unui tip de sprijin potrivit.",
    assessChildrenWhy4: "Pentru a stabili dacă este nevoie de consiliere psihologică, de sprijin educațional sau de evaluarea altui specialist.",
    assessChildrenProcessTitle: "Cum se desfășoară evaluarea",
    assessChildrenProcessText: "Procesul începe cu o întâlnire cu părinții, în care clarificăm motivul evaluării, istoricul de dezvoltare și situația actuală. Urmează una sau mai multe întâlniri cu copilul sau adolescentul, în care sunt folosite instrumente potrivite vârstei și activități structurate, iar la copiii mici jocul și desenul. Cu acordul familiei, pot fi solicitate informații și din mediul școlar.",
    assessChildrenFeedbackTitle: "Feedback și recomandări practice",
    assessChildrenFeedbackText: "Rezultatele sunt discutate cu părinții într-o ședință de feedback, într-un limbaj clar, cu accent pe punctele forte ale copilului și pe dificultățile care necesită sprijin. Recomandările sunt practice și aplicabile acasă și la școală, iar atunci când este cazul includ consiliere psihologică, sprijin educațional sau îndrumarea către un alt specialist. Adolescenții primesc un feedback adaptat vârstei, în limitele cadrului etic.",
    assessChildrenNote: "Evaluarea psihologică pentru copii este un proces profesionist, realizat de psiholog împreună cu familia, și nu trebuie confundată cu testele de screening gratuite de pe acest site, care oferă doar o orientare generală.",
    assessChildrenTestsIntro: "Teste de screening gratuite, cu rol orientativ:",
    assessChildrenTest1Anchor: "Test de adaptare școlară (6–8 ani)",
    assessChildrenTest2Anchor: "Test de motivație pentru învățare (8–12 ani)",

    adtHeroDesc: "Un spațiu sigur și confidențial, disponibil online, în care poți vorbi deschis despre ceea ce te preocupă, poți înțelege mai bine ceea ce trăiești și poți găsi, pas cu pas, modalități mai bune de a face față dificultăților din viața ta.",

    adtNewTitleL1: "Prima dată la psihoterapie?",
    adtNewTitleL2: "Poți începe de aici.",
    adtNewLeft: "Mulți oameni aleg să vină la terapie atunci când se simt copleșiți, blocați sau când ceva important din viața lor nu mai funcționează așa cum și-ar dori. Prima întâlnire este un spațiu de cunoaștere, în care explorăm împreună ceea ce te aduce în terapie și contextul în care apar aceste dificultăți.",
    adtNewRight1: "Nu este nevoie să povestești toată istoria de la început. Vom merge în ritmul tău, punând întrebări și clarificând treptat lucrurile importante pentru tine.",
    adtNewRight2: "Vei fi ascultat(ă) cu interes, empatie și fără judecată, într-un cadru profesionist și confidențial.",

    adtWorkTitle: "Cu ce dificultăți te poate ajuta psihoterapia online?",
    adtWorkIntro: "Temele aduse în terapie sunt diverse. Mai jos sunt câteva dintre ariile frecvente în care te pot sprijini:",
    adtConcern1Title: "Anxietate și atacuri de panică",
    adtConcern1Desc: "Neliniște, griji excesive, atacuri de panică și tendința de a anticipa mereu ce e mai rău.",
    adtConcern2Title: "Depresie și dispoziție scăzută",
    adtConcern2Desc: "Lipsa de energie, pierderea interesului, sentimente de tristețe sau gol interior.",
    adtConcern3Title: "Stres cronic și burnout",
    adtConcern3Desc: "Oboseală persistentă, tensiune, sentimentul că nu mai faci față cerințelor.",
    adtConcern4Title: "Traumă și experiențe dificile",
    adtConcern4Desc: "Evenimente dureroase din trecut care încă îți influențează prezentul.",
    adtConcern5Title: "Relații și atașament",
    adtConcern5Desc: "Dificultăți în relații, tipare repetitive, teama de abandon sau nevoia de apropiere.",
    adtConcern6Title: "Stimă de sine și autocritică",
    adtConcern6Desc: "Lipsa încrederii, autocritică severă și o imagine de sine negativă.",
    adtConcern7Title: "Reglare emoțională",
    adtConcern7Desc: "Dificultăți în a gestiona emoții intense precum furia, tristețea sau frustrarea.",
    adtConcern8Title: "Doliu și pierdere",
    adtConcern8Desc: "Pierderea unei persoane dragi și ajustarea la schimbările majore din viață.",
    adtConcern9Title: "Maternitate și perioada postpartum",
    adtConcern9Desc: "Adaptarea la rolul de părinte, schimbări emoționale și identitate după naștere.",
    adtConcern10Title: "Studii universitare și presiune academică",
    adtConcern10Desc: "Stres, lipsă de motivație, perfecționism și dificultăți de adaptare la viața universitară.",
    adtConcern11Title: "Muncă și tranziții profesionale",
    adtConcern11Desc: "Provocări la locul de muncă, epuizare, nesiguranță și schimbări de carieră sau de direcție profesională.",
    adtConcern12Title: "Perfecționism și procrastinare",
    adtConcern12Desc: "Standarde foarte înalte, teama de eșec și dificultăți în a începe sau finaliza sarcini.",
    adtConcern13Title: "Limite personale și comunicare",
    adtConcern13Desc: "Dificultăți în a spune „nu”, relații dezechilibrate și nevoi care rămân neexprimate.",
    adtConcern14Title: "Comportamente compulsive și consum problematic",
    adtConcern14Desc: "Tipare de comportament dificil de controlat și consum de substanțe care creează probleme în viața ta.",
    adtConcern15Title: "Identitate și autocunoaștere",
    adtConcern15Desc: "Întrebări legate de sens, valori, direcție în viață și o mai bună înțelegere a propriei persoane.",

    adtProcessTitle: "Cum se desfășoară psihoterapia individuală online?",
    adtStep1Title: "Prima întâlnire",
    adtStep1Desc: "Explorăm împreună ceea ce te aduce în terapie și contextul în care apar aceste dificultăți.",
    adtStep2Title: "Obiective inițiale",
    adtStep2Desc: "Formulăm împreună obiective concrete și realiste, în funcție de nevoile și resursele tale.",
    adtStep3Title: "Lucrul terapeutic",
    adtStep3Desc: "Lucrăm în ritmul tău, explorăm ceea ce este important pentru tine și identificăm strategii și perspective noi, adaptate situației tale.",
    adtStep4Title: "Reevaluarea progresului",
    adtStep4Desc: "Revenim periodic asupra obiectivelor, observăm ce s-a schimbat și ajustăm direcția în funcție de ceea ce este util pentru tine.",
    adtCalloutText: "Pornim de la dificultățile pe care le aduci, formulăm împreună obiective concrete și observabile și le ajustăm pe măsură ce înțelegem mai bine nevoile tale.",

    adtPracticalTitle: "Detalii practice",
    adtPracticalIntro: "Informații utile pentru a-ți organiza ședințele în mod cât mai simplu și confortabil.",
    adtPracticalCol1Title: "Online / la cabinet\nîn Chișinău",
    adtPracticalCol1Desc: "Ședințele pot avea loc online sau la cabinet, în Chișinău, în funcție de preferințe și posibilitățile tale.",
    adtPracticalCol2Title: "Durata unei ședințe de psihoterapie individuală este de 50 de minute / 250 RON.",
    adtPracticalCol2Desc: "",
    adtPracticalCol3Title: "Reducere de 10%",
    adtPracticalCol3Desc: "Studenții și persoanele aflate în concediu de creștere a copilului beneficiază de reducere.",
    adtPracticalCol3Extra: "Tarif redus: 225 RON / ședință.",
    adtPracticalCol1Chip1: "Platformă securizată",
    adtPracticalCol1Chip2: "Chișinău",
    adtPracticalCol2Chip1: "50 minute",
    adtPracticalCol2Chip2: "250 RON",
    adtPracticalCol3Chip1: "Studenți",
    adtPracticalCol3Chip2: "Concediu parental",

    adtFaqTitle: "Întrebări frecvente",
    adtFaqIntro: "Mai jos găsești răspunsuri la câteva întrebări care apar des. Dacă ai alte curiozități, mă poți contacta oricând.",
    adtFaq1Q: "Cum știu dacă psihoterapia mi se potrivește?",
    adtFaq1A: "Dacă simți că te confrunți cu dificultăți emoționale, relaționale sau personale care îți afectează calitatea vieții, psihoterapia poate fi un sprijin util. Prima întâlnire este tocmai pentru a explora împreună dacă abordarea mea și contextul oferit ți se potrivesc.",
    adtFaq2Q: "Cât durează o ședință?",
    adtFaq2A: "O ședință de psihoterapie individuală durează 50 de minute și poate avea loc online sau la cabinet, în Chișinău.",
    adtFaq3Q: "Cât timp durează terapia?",
    adtFaq3A: "Durata procesului terapeutic variază în funcție de obiectivele și nevoile fiecărei persoane. Unele teme se pot clarifica în câteva ședințe, altele necesită un parcurs mai lung. Vom reevalua periodic progresul împreună.",
    adtFaq4Q: "Ședințele sunt confidențiale?",
    adtFaq4A: "Da. Toate informațiile discutate în cadrul ședințelor sunt strict confidențiale, în conformitate cu codul deontologic al psihologilor.",
    adtFaq5Q: "Pot face ședințele online?",
    adtFaq5A: "Da. Ședințele online se desfășoară pe o platformă securizată și sunt la fel de eficiente ca cele față în față, pentru majoritatea situațiilor.",
    adtFaq6Q: "Cum pot programa o ședință?",
    adtFaq6A: "Poți programa o ședință direct prin butonul de rezervare, care te va conduce către calendarul meu online. Dacă ai întrebări înainte de programare, îmi poți scrie oricând.",

    adtCtaTitle: "Poți începe cu o conversație.",
    adtCtaText: "Dacă simți că este momentul să faci un pas spre mai multă claritate și echilibru, te invit să programezi o ședință. Putem discuta despre ceea ce te preocupă și despre cum te pot sprijini în procesul tău.",
    ccaTitleL1: "Consiliere psihologică online",
    ccaTitleL2: "pentru copii și adolescenți",
    ccaMeta: "Online / la cabinet · 50 minute · 50 €",
    ccaHeroDesc: "Ca psiholog pentru copii și adolescenți, ofer sprijin psihologic online, adaptat nivelului de dezvoltare al copilului sau adolescentului și construit în jurul nevoilor, resurselor și contextului său de viață.",
    ccaFormatLabel: "Format",
    ccaFormatValue: "Online / la cabinet",
    ccaLanguagesLabel: "Limbi",
    ccaLanguagesValue: "Engleză · Română",
    ccaDurationLabel: "Durată",
    ccaDurationValue: "50 minute",
    ccaFeeLabel: "Tarif",
    ccaFeeValue: "200–250 RON",
    ccaWhatTitle: "Ce este consilierea psihologică?",
    ccaWhatText1: "Un spațiu susținător și structurat în care copiii și adolescenții își pot înțelege mai bine emoțiile, relațiile și dificultățile actuale.",
    ccaWhatText2: "În funcție de vârstă și de nevoi, ședințele pot include conversație, joc terapeutic, desen, povești, activități centrate pe emoții și alte tehnici potrivite vârstei.",
    ccaProcessTitle: "Cum se desfășoară consilierea pentru copii și adolescenți?",
    ccaProcess1: "Consultație iniţială cu părinții",
    ccaProcess2: "Întâlnirea cu copilul sau adolescentul",
    ccaProcess3: "Lucrul psihologic continuu",
    ccaProcess4: "Ghidarea părinților, atunci când este potrivit",
    ccaSupportTitle: "Când poate fi utilă consilierea psihologică pentru copii?",
    ccaSupport1Title: "Dificultăți emoționale",
    ccaSupport1Desc: "Anxietate, temeri, tristețe, dispoziție scăzută.",
    ccaSupport2Title: "Provocări școlare și educaționale",
    ccaSupport2Desc: "Adaptare, motivație, stres academic.",
    ccaSupport3Title: "Dificultăți comportamentale",
    ccaSupport3Desc: "Conflicte, impulsivitate, comportament opozant.",
    ccaSupport4Title: "Schimbări și tranziții de viață",
    ccaSupport4Desc: "Începutul școlii, schimbări în familie, relocare, pierdere și altele.",
    ccaBookTitle: "Programează o ședință",
    ccaBookText: "Disponibil online și la cabinet · engleză și română · 50 €",
    ccaQuestionTitle: "Ai o întrebare?",
    ccaQuestionText: "Dacă nu ești sigur dacă consilierea este potrivită, îmi poți descrie scurt îngrijorările înainte de a programa o ședință.",
    ccaEmail: "Email",

    vocTitleL1: "Consiliere în carieră",
    vocTitleL2: "și orientare vocațională",
    vocAudience: "Adolescenți și tineri adulți",
    vocHeroDesc: "Un proces structurat de explorare a intereselor, punctelor forte, valorilor personale și a opțiunilor educaționale sau profesionale, menit să susțină decizii mai clare și mai bine informate privind parcursul academic și profesional.",
    vocFormatLabel: "Format",
    vocFormatValue: "Online / la cabinet",
    vocLanguagesLabel: "Limbi",
    vocLanguagesValue: "Engleză · Română",
    vocDurationLabel: "Durată",
    vocDurationValue: "50 de minute",
    vocFeeLabel: "Tarif",
    vocFeeValue: "200–250 RON",
    vocWhoTitle: "Pentru cine este utilă consilierea în carieră?",
    vocWhatTitle: "Ce este consilierea vocațională?",
    vocWhatText1: "Un cadru structurat în care interesele, aptitudinile și valorile personale sunt explorate treptat, pentru ca opțiunile educaționale și profesionale să devină mai clare.",
    vocWhatText2: "Procesul nu oferă răspunsuri prefabricate, ci sprijină înțelegerea propriului profil și luarea unor decizii informate, adaptate vârstei și contextului de viață.",    vocWhoNote: "Nu trebuie să afli singur răspunsul.",
    vocWho1Title: "Elevi la tranziții școlare importante",
    vocWho1Desc: "Pentru adolescenții care finalizează gimnaziul și se gândesc la următorul parcurs educațional.",
    vocWho2Title: "Elevi de liceu",
    vocWho2Desc: "Pentru tinerii aproape de absolvire, în fața alegerii facultății sau a altor decizii academice.",
    vocWho3Title: "Tineri adulți în căutarea unei direcții",
    vocWho3Desc: "Pentru cei care nu sunt siguri ce să studieze, ce tip de muncă li se potrivește sau ce pas să urmeze.",
    vocWho4Title: "Planificarea începutului de carieră",
    vocWho4Desc: "Pentru cei care se pregătesc de angajare, își reevaluează opțiunile sau își clarifică obiectivele profesionale.",
    vocHelpTitle: "Cum te ajută orientarea vocațională?",
    vocHelpNote: "Mai multă claritate. Decizii mai încrezătoare.",
    vocHelp1Title: "Clarificarea intereselor și a punctelor forte",
    vocHelp1Desc: "Explorăm aptitudini, preferințe și resurse personale.",
    vocHelp2Title: "Decizii educaționale",
    vocHelp2Desc: "Alegerea între opțiuni de studiu, programe sau parcursuri academice.",
    vocHelp3Title: "Direcția în carieră",
    vocHelp3Desc: "Identificarea profesiilor și a mediilor de lucru mai potrivite.",
    vocHelp4Title: "Decizie și încredere",
    vocHelp4Desc: "Dezvoltarea clarității, a obiectivelor realiste și a unor alegeri mai sigure.",
    vocProcessTitle: "Cum funcționează procesul",
    vocProcessNote: "O abordare structurată și suportivă.",
    vocStep1Title: "Discuția inițială",
    vocStep1Desc: "Clarificăm întrebarea, contextul și decizia cu care te confrunți.",
    vocStep2Title: "Explorarea profilului",
    vocStep2Desc: "Explorăm interese, valori, puncte forte și abilități relevante.",
    vocStep3Title: "Cartografierea opțiunilor",
    vocStep3Desc: "Analizăm posibilitățile educaționale și profesionale potrivite.",
    vocStep4Title: "Plan de acțiune",
    vocStep4Desc: "Organizăm pașii următori pentru studiu, aplicații sau direcția de carieră.",
    vocIncludeTitle: "Ce poate include procesul",
    vocIncludeNote: "Adaptat situației tale.",
    vocInc1: "Interese",
    vocInc2: "Valori",
    vocInc3: "Aptitudini",
    vocInc4: "Parcursuri educaționale",
    vocInc5: "Alegerea facultății",
    vocInc6: "Preferințe de muncă",
    vocInc7: "Stabilirea obiectivelor",
    vocInc8: "Luarea deciziilor",
    vocInc9: "Motivație",
    vocInc10: "Încredere",
    vocBookTitle: "Programează o ședință",
    vocBookText: "Disponibil online și la cabinet · engleză și română · 50 de minute · 50 €",
    vocQuestionTitle: "Ai o întrebare?",
    vocQuestionText: "Dacă nu ești sigur dacă consilierea vocațională este potrivită, îmi poți descrie scurt situația înainte de a programa o ședință.",

    evlTitleL1: "Evaluare psihologică și",
    evlTitleL2: "psihodiagnostic",
    evlHeroDesc: "Această pagină reunește serviciile de evaluare psihologică pentru copii, adolescenți și adulți. Este un proces orientat spre înțelegerea mai clară a funcționării emoționale, cognitive, comportamentale și relaționale. Evaluarea nu are rol de etichetare sau judecată, ci de clarificare, autocunoaștere și identificare a resurselor, dificultăților și direcțiilor de sprijin potrivite.",
    evlCta: "Solicită o evaluare",
    evlDisclaimer: "Evaluarea clinică și educațională oferită aici nu reprezintă expertiză judiciară sau medico-legală.",
    evlFormatLabel: "Format",
    evlFormatValue: "Online / la cabinet",
    evlDurationLabel: "Durată",
    evlDurationValue: "15–50 minute",
    evlFeeLabel: "Tarif",
    evlFeeValue: "100–250 RON",
    evlConfLabel: "Confidențialitate",
    evlConfValue: "Rezultatele sunt comunicate doar beneficiarului; în cazul minorilor, părintelui sau reprezentantului legal, în limitele cadrului profesional și etic.",
    evlTypesTitle: "Alege tipul de evaluare",
    evlTypeChildrenTitle: "Psihodiagnostic pentru copii și adolescenți",
    evlTypeChildrenText: "Pentru înțelegerea motivației pentru învățare, emoțiilor, comportamentului, adaptării și relațiilor.",
    evlTagC1: "motivație",
    evlTagC2: "emoții",
    evlTagC3: "reglare emoțională",
    evlTagC4: "comportament",
    evlTagC5: "adaptare școlară",
    evlTagC6: "relații",
    evlTypeAdultsTitle: "Psihodiagnostic pentru adulți",
    evlTypeAdultsText: "Pentru clarificarea personalității, stresului, burnoutului, dificultăților relaționale și funcționării ocupaționale.",
    evlTagA1: "personalitate",
    evlTagA2: "stres",
    evlTagA3: "burnout",
    evlTagA4: "relațional",
    evlTagA5: "temperament",
    evlTagA6: "ocupațional",
    evlIncludeTitle: "Ce poate include evaluarea?",
    evlIncChildrenCol: "Pentru copii și adolescenți",
    evlIncAdultsCol: "Pentru adulți",
    evlIncC1Title: "Motivație pentru învățare",
    evlIncC1Desc: "interes, implicare, dificultăți școlare",
    evlIncC2Title: "Emoții și reglare emoțională",
    evlIncC2Desc: "anxietate, sensibilitate, exprimare emoțională",
    evlIncC3Title: "Comportament și adaptare",
    evlIncC3Desc: "impulsivitate, opoziționism, dificultăți de adaptare",
    evlIncC4Title: "Relații și integrare",
    evlIncC4Desc: "colegi, familie, climat școlar",
    evlIncC5Title: "Resurse personale",
    evlIncC5Desc: "puncte forte și nevoi de sprijin",
    evlIncA1Title: "Personalitate",
    evlIncA1Desc: "stiluri de funcționare și trăsături",
    evlIncA2Title: "Stres și burnout",
    evlIncA2Desc: "suprasolicitare, epuizare, echilibru",
    evlIncA3Title: "Relațional",
    evlIncA3Desc: "dinamici relaționale și atașament",
    evlIncA4Title: "Ocupațional",
    evlIncA4Desc: "adaptare profesională și funcționare la muncă",
    evlIncA5Title: "Resurse și coping",
    evlIncA5Desc: "mecanisme de adaptare și reziliență",
    evlIncNote: "Instrumentele sunt selectate în funcție de scopul evaluării, vârstă și particularitățile fiecărei situații.",
    evlProcessTitle: "Cum decurge procesul?",
    evlStep1Title: "Clarificarea solicitării",
    evlStep1Desc: "Stabilim obiectivul evaluării și întrebările la care dorim să răspundem.",
    evlStep2Title: "Alegerea instrumentelor",
    evlStep2Desc: "Sunt selectate metodele potrivite în funcție de vârstă și scop.",
    evlStep3Title: "Administrare și interpretare",
    evlStep3Desc: "Aplicarea instrumentelor și analiza integrată a rezultatelor.",
    evlStep4Title: "Feedback și recomandări",
    evlStep4Desc: "Primești concluzii clare și direcții practice de intervenție sau sprijin.",
    evlImportantTitle: "Ce este important să știi",
    evlImp1Title: "Nu este o etichetă",
    evlImp1Text: "Scopul evaluării este înțelegerea, nu judecata sau reducerea persoanei la un scor.",
    evlImp2Title: "Proces confidențial",
    evlImp2Text: "Rezultatele sunt discutate într-un cadru confidențial și comunicate doar persoanei evaluate sau, în cazul minorilor, părintelui / reprezentantului legal.",
    evlImp3Title: "Durată și cost flexibile",
    evlImp3Text: "Durata și costul depind de obiectivul evaluării, instrumentele utilizate și complexitatea cazului.",

    questionHeading: "Ai o întrebare înainte de programare?",
    questionText: "Dacă ai nevoie de o clarificare privind disponibilitatea, formatul ședințelor sau prima întâlnire, îmi poți scrie direct.",
    questionWhatsapp: "WhatsApp",
    servicesTitleOld: "Nu toate tipurile de ajutor psihologic sunt la fel",
    servicesSubtitle: "Mulți oameni nu știu exact ce li se potrivește. Aici găsești diferența simplă.",
    serviceRecommended: "Recomandat",
    serviceDuration: "Durată:",
    serviceSuitable: "Potrivit dacă:",
    
    service1Title: "Psihoterapie Integrativă",
    service1Price: "700 lei",
    service1Duration: "medie-lungă",
    service1Desc: "Proces de profunzime orientat spre schimbări stabile.",
    service1Point1: "Anxietatea revine constant",
    service1Point2: "Ai tipare relaționale repetitive",
    service1Point3: "Vrei să înțelegi de ce reacționezi cum reacționezi",
    service1Point4: "Vrei schimbare reală, nu doar soluții rapide",
    
    service2Title: "Consiliere Psihologică",
    service2Price: "600 lei",
    service2Duration: "scurtă",
    service2Desc: "Intervenție focalizată pe o situație concretă.",
    service2Point1: "Trebuie să iei o decizie",
    service2Point2: "Ai un blocaj punctual",
    service2Point3: "Ai nevoie de orientare clară",
    service2Point4: "Vrei structură rapidă",
    
    service3Title: "Dezvoltare Personală",
    service3Price: "600 lei",
    service3Duration: "variabilă",
    service3Desc: "Optimizare funcționare și autocunoaștere.",
    service3Point1: "Nu ai o problemă majoră dar vrei claritate",
    service3Point2: "Vrei să îți îmbunătățești relațiile",
    service3Point3: "Vrei să îți înțelegi emoțiile",
    service3Point4: "Vrei performanță personală mai stabilă",
    
    servicesNote: "Dacă nu ești sigur ce ți se potrivește,",
    servicesNoteHighlight: "alegem împreună în prima ședință.",
    
    // Issues
    issuesLabel: "Probleme abordate",
    issuesTitle: "Cu ce te pot ajuta",
    issue1: "Anxietate",
    issue2: "Burnout",
    issue3: "Depresie",
    issue4: "Stres",
    issue5: "Stimă de sine",
    issue6: "Relații",
    issue7: "Reglare emoțională",
    issue8: "Procrastinare",
    issue9: "Sensibilitate ridicată",
    issue10: "Dificultăți educaționale",
    issue11: "Autocunoaștere",
    
    // How It Works
    howLabel: "Procesul terapeutic",
    howTitle: "Cum funcționează terapia",
    howStep1Title: "Prima întâlnire",
    howStep1Desc: "Clarificăm ce se întâmplă și stabilim direcția potrivită pentru tine.",
    howStep2Title: "Identificăm tiparele",
    howStep2Desc: "Explorăm împreună ce stă la baza dificultăților tale actuale.",
    howStep3Title: "Intervenții și exerciții",
    howStep3Desc: "Aplicăm tehnici și exerciții adaptate nevoilor tale specifice.",
    howStep4Title: "Construim autonomie",
    howStep4Desc: "Dezvolți resurse proprii pentru a funcționa independent.",
    howNote: "Schimbarea rareori se produce dintr-odată. Devine vizibilă treptat, în ceea ce înțelegi, alegi și faci diferit.",
    
    // About
    aboutLabel: "Despre mine",
    aboutName: "Ruxandra Sterbet",
    aboutTitle: "Psiholog clinician · Psihoterapeut cu formare în psihoterapie integrativă",
    aboutSubtitle: "Doctorandă în psihologie · Asistent universitar · Consilier educațional",
    aboutExperience: "5 ani de experiență în lucrul psihologic și psihoterapeutic cu copii, adolescenți și adulți",
    aboutReadMore: "Află mai mult despre parcursul meu",
    aboutGetInTouch: "Contactează-mă",
    aboutCredentials1: "Psiholog clinician · Psihoterapeut cu formare în psihoterapie integrativă · Consilier educațional",
    aboutCredentials2: "Doctorandă în psihologie · Cercetătoare · Asistent universitar",
    aboutPara1: "Sunt psiholog clinician și psihoterapeut cu formare în psihoterapie integrativă, cu experiență în lucrul cu copii, adolescenți și adulți. Activitatea mea profesională reunește practica psihoterapeutică, consilierea psihologică și educațională, evaluarea psihologică, predarea universitară și cercetarea.",
    aboutPara2: "În munca mea adopt o abordare individualizată și integrativă, luând în considerare factorii emoționali, cognitivi, relaționali și contextuali care modelează experiența fiecărei persoane și dificultățile sale actuale. Îmi propun să ofer un spațiu sigur, colaborativ și fundamentat profesional, în care schimbarea psihologică cu sens poate avea loc.",
    aboutPara3: "În paralel cu practica clinică, sunt implicată în predarea universitară și în cercetarea doctorală în psihologie, cu un accent particular pe motivația pentru învățare și bunăstarea emoțională a copiilor în contextul digitalizării.",
    aboutHl1Title: "Practică clinică",
    aboutHl1Desc: "Peste 5 ani de experiență în lucrul cu copii, adolescenți și adulți",
    aboutHl2Title: "Consiliere educațională",
    aboutHl2Desc: "Sprijin pentru adaptarea școlară, dezvoltarea socio-emoțională și orientarea educațională.",
    aboutHl3Title: "Activitate academică și de cercetare",
    aboutHl3Desc: "Îmbină cercetarea psihologică, predarea universitară și practica aplicată.",
    aboutHl4Title: "Abordare integrativă",
    aboutHl4Desc: "Fundamentată pe dovezi, flexibilă și adaptată nevoilor tale",
    aboutFullTitle: "Despre mine",
    aboutFullBack: "Înapoi la pagina principală",
    aboutFullPlaceholder: "Textul complet al acestei pagini urmează să fie adăugat.",
    aboutYears: "ani experiență",
    
    // Pricing
    pricingLabel: "Investiție",
    pricingTitle: "Prețuri",
    pricingSession: "Ședință: 50 minute",
    pricingDesc1: "Proces profund orientat spre schimbări de durată",
    pricingDesc2: "Intervenție scurtă pentru situații concrete",
    pricingDesc3: "Autocunoaștere și optimizare personală",
    pricingPackages: "Pachete Psihoterapie",
    pricingPkg1: "4 ședințe/lună",
    pricingPkg2: "3 ședințe/lună",
    pricingPkg3: "2 ședințe/lună",
    pricingPerSession: "/ ședință",
    pricingCancel: "Anulare sau reprogramare: minim 24h înainte",
    pricingCta: "Programează",
    
    // Booking
    bookingEyebrow: "Următorul pas",
    bookingTitle: "Programează o ședință",
    bookingDesc: "Prima întâlnire durează 50 de minute și te ajută să înțelegi clar de ce ai nevoie și cum putem lucra împreună.",
    bookingAvailability: "Disponibilitate",
    bookingFormatTitle: "Online / La cabinet",
    bookingFormatDesc: "Ședințele sunt disponibile online sau la cabinetul de psihologie și psihoterapie.",
    bookingMapsLink: "Vezi locația pe Google Maps →",
    bookingMapsAria: "Vezi cabinetul Ruxandra Sterbet pe Google Maps",
    bookingDurationTitle: "Durata ședinței",
    bookingDurationValue: "50 de minute",
    bookingCardTitle: "Rezervă ședința ta",
    bookingCardDesc: "Alege formatul care ți se potrivește cel mai bine (online sau la cabinet).",
    bookingSchedule: "Program",
    bookingWeekdays: "Luni – Vineri: 15:00 – 19:00",
    bookingWeekend: "Weekend: 10:00 – 15:00",
    bookingMethods: "Metode de contact",
    bookingWhatsapp: "WhatsApp",
    bookingForm: "Formular contact",
    bookingPromoTitle: "Prima ședință cu reducere!",
    bookingPromoText: "Folosește codul",
    bookingPromoCode: "TERAPIE100",
    bookingPromoDiscount: "pentru 100 lei reducere la prima programare.",
    bookingOnline: "Ședințe Online",
    bookingOnlineDesc: "Toate ședințele se desfășoară online prin videoconferință, oferindu-ți confortul și discreția de care ai nevoie.",
    bookingFormCta: "Completează formularul",
    bookingCalendly: "Calendar online (Calendly)",
    bookingCalendlyCta: "Rezervă în calendar",
    
    // Articles
    articlesLabel: "Resurse",
    articlesTitle: "Articole și resurse",
    articlesSubtitle: "Conținut util pentru înțelegere și dezvoltare personală",
    articleCat1: "Teme terapeutice",
    articleCat2: "Teste orientative",
    articleCat3: "Despre terapie",
    articleCat4: "Sănătate mentală",
    articleCat5: "Recomandări cărți și filme",
    articlesNote: "Articolele vor fi disponibile în curând.",
    
    // Psychological Tests
    testsLabel: "Teste psihologice",
    testsTitle: "Teste psihologice orientative",
    testsSubtitle: "Descoperă resurse și teste orientative care te pot ajuta să înțelegi mai bine ce simți.",
    testsNote: "Testele psihologice vor fi disponibile în curând.",
    testsAdultsAssessmentIntro: "Pentru un proces profesionist, realizat de psiholog, vezi",
    testsAdultsAssessmentAnchor: "evaluarea psihologică pentru adulți",
    testsChildrenTitle: "Teste psihologice pentru copii și adolescenți",
    testsChildrenSubtitle: "Instrumente de evaluare psihologică pentru explorarea funcționării cognitive, emoționale, comportamentale, relaționale, școlare și sociale a copiilor și adolescenților.",
    assessSvcHeading: "Evaluări psihologice",
    assessSvcIntro: "Servicii de evaluare psihologică individuală, adaptate vârstei, particularităților de dezvoltare și motivului adresării.",
    assessSvcCta: "Află mai multe",
    assessSvc1Title: "Pregătirea pentru debutul școlar și adaptarea în clasa I",
    assessSvc1Desc: "Evaluare destinată copiilor preșcolari și elevilor din clasa I, orientată spre înțelegerea nivelului de pregătire pentru debutul școlar și a modului de adaptare la cerințele mediului educațional.",
    assessSvc2Title: "Serviciu de evaluare 2 (titlu în așteptare)",
    assessSvc2Desc: "Descrierea acestui serviciu de evaluare psihologică va fi completată ulterior. Structura cardului rămâne consistentă cu celelalte servicii din această secțiune.",
    assessSvc3Title: "Serviciu de evaluare 3 (titlu în așteptare)",
    assessSvc3Desc: "Descrierea acestui serviciu de evaluare psihologică va fi completată ulterior. Structura cardului rămâne consistentă cu celelalte servicii din această secțiune.",
    assessSvc4Title: "Serviciu de evaluare 4 (titlu în așteptare)",
    assessSvc4Desc: "Descrierea acestui serviciu de evaluare psihologică va fi completată ulterior. Structura cardului rămâne consistentă cu celelalte servicii din această secțiune.",
    assessSvc5Title: "Serviciu de evaluare 5 (titlu în așteptare)",
    assessSvc5Desc: "Descrierea acestui serviciu de evaluare psihologică va fi completată ulterior. Structura cardului rămâne consistentă cu celelalte servicii din această secțiune.",
    testsFreeHeading: "Teste gratuite",
    testsFreeIntro: "Completează unul dintre testele disponibile și primește rezultatul orientativ pe e-mail, împreună cu o scurtă explicație a scorului.",
    testsFreeDisclaimer: "Testele gratuite au rol de screening și orientare și nu înlocuiesc evaluarea psihologică individuală.",
    testsCardFree: "Completează gratuit",
    evlCtaAssessChildren: "Evaluare psihologică pentru copii și adolescenți",
    evlCtaAssessAdults: "Evaluare psihologică pentru adulți",
    testSchoolAdjustmentName: "Adaptarea școlară",
    testSchoolAdjustmentAnchor: "Test de adaptare școlară",
    testLearningMotivationAnchor: "Test de motivație pentru învățare",
    testSchoolAdjustmentAge: "6–8 ani",
    testSchoolAdjustmentTime: "10 minute",
    testLearningMotivationName: "Motivația pentru învățare",
    testLearningMotivationAge: "8–12 ani",
    testLearningMotivationTime: "10 minute",
    testRunnerBack: "Înapoi la teste",
    testRunnerSoonTitle: "Testul va fi disponibil în curând",
    testRunnerSoonText: "Întrebările și modul de interpretare sunt în pregătire. Când testul va fi activ, îl vei putea completa direct aici, iar la final vei putea introduce adresa de e-mail pentru a primi rezultatul orientativ.",
    testRunnerEmailNote: "Trimiterea rezultatelor pe e-mail nu este încă activă. Va fi pornită odată cu publicarea testului.",
    testsAdultsTitle: "Teste psihologice pentru adulți",
    testsAdultsSubtitle: "O selecție de teste orientative pentru adulți, care te pot ajuta să îți clarifici ceea ce simți înainte de o discuție cu un specialist.",
    testsBack: "Înapoi la pagina principală",
    testsCardAction: "Începe testul",
    testsCardActionSoon: "În curând",
    testsAgeLabel: "Vârstă",
    testsPlaceholderName: "Test în curând",
    testsPlaceholderDesc: "Aici va fi adăugată descrierea scurtă a testului.",
    testsPlaceholderAge: "—",
    testsComingSoon: "Testele vor fi adăugate în curând.",

    // FAQ
    faqLabel: "Întrebări frecvente",
    faqTitle: "Ai întrebări?",
    faqQ1: "Cu cine lucrez?",
    faqA1: "Lucrez cu copii de la 7 ani, adolescenți și adulți, oferind sprijin psihologic adaptat nevoilor și experiențelor fiecărei persoane. Ședințele sunt disponibile online pentru persoanele din România, Republica Moldova și diaspora, precum și față în față, la Chișinău. Putem lucra în limba română sau engleză, într-un cadru confidențial, în care să te simți ascultat și respectat.",
    faqQ2: "Ședințele sunt disponibile online sau la cabinet?",
    faqA2: "Ambele opțiuni sunt disponibile.\n\nȘedințele online sunt disponibile internațional și se desfășoară printr-o platformă securizată de videoconsultație.\n\nȘedințele la cabinet sunt disponibile momentan în Chișinău, Republica Moldova.\n\nPoți alege formatul cel mai potrivit pentru situația și preferințele tale.",
    faqQ3: "Cât durează o ședință?",
    faqA3: "Ședințele de psihoterapie, consiliere psihologică și consiliere vocațională durează, în general, 50 de minute.\n\nEvaluarea psihologică și psihodiagnoza nu respectă întotdeauna același interval de timp. Durata depinde de scopul evaluării, de instrumentele psihologice utilizate și de complexitatea procesului. Prin urmare, unele evaluări pot necesita mai mult de o întâlnire.",
    faqQ4: "Cât costă o ședință?",
    faqA4: "Tariful variază în funcție de serviciul de care ai nevoie. Pentru detalii despre serviciile oferite, durata ședințelor și tarifele aferente, te invit să consulți secțiunea „Servicii” de mai sus.",
    faqQ5: "Psihoterapeutul prescrie medicamente?",
    faqA5: "Nu. Psihoterapeuții și psihologii nu prescriu medicamente.\n\nMedicamentele pot fi prescrise de un medic, precum medicul psihiatru. Atunci când este potrivit, lucrul psihologic sau psihoterapeutic se poate desfășura în paralel cu tratamentul psihiatric, iar o consultație psihiatrică poate fi recomandată dacă o evaluare medicală suplimentară ar fi benefică.",
    faqQ6: "Ce se întâmplă în prima ședință?",
    faqA6: "Prima întâlnire este o oportunitate de a înțelege ce te aduce în terapie, de a explora dificultățile și așteptările tale actuale și de a clarifica ce tip de sprijin psihologic ar fi cel mai potrivit.\n\nNu este nevoie să vii cu o problemă sau cu un obiectiv terapeutic perfect definit. Acestea pot fi clarificate împreună, pe parcursul procesului.",
    faqQ7: "De câte ședințe voi avea nevoie?",
    faqA7: "Nu există un număr predeterminat de ședințe care să se potrivească tuturor.\n\nDurata procesului depinde de natura dificultăților, de obiectivele terapeutice, de nevoile individuale și de evoluția în timp. Unele persoane caută sprijin pentru o problemă specifică, pe o perioadă mai scurtă, în timp ce altele aleg un proces terapeutic mai îndelungat.\n\nNevoia și direcția terapiei sunt revizuite în colaborare, pe tot parcursul procesului.",
    
    // Testimonials
    testimonialLabel: "Experiențe",
    testimonialTitle: "De ce aleg oamenii terapia",
    testimonialQuote: '"Persoanele care au început terapia nu au venit pentru că «aveau timp», ci pentru că aveau nevoie de claritate."',
    testimonialText: "Experiențele lor sunt diferite, dar au un lucru comun:",
    testimonialHighlight: "au înțeles mai bine ce li se întâmplă.",
    
    // Contact Form
    contactLabel: "Contact",
    contactTitle: "Trimite un mesaj",
    contactSubtitle: "Completează formularul de mai jos și te voi contacta în cel mai scurt timp.",
    contactName: "Numele complet",
    contactNamePlaceholder: "Introduceți numele complet",
    contactEmail: "Email",
    contactEmailPlaceholder: "email@exemplu.com",
    contactPhone: "Telefon",
    contactPhonePlaceholder: "+373 XX XXX XXX",
    contactSessionType: "Tipul ședinței preferat",
    contactOnline: "Online – Videoconferință",
    contactCabinet: "Cabinet – Chișinău",
    contactSubject: "Subiect",
    contactSubjectPlaceholder: "ex: Programare prima ședință",
    contactMessage: "Mesaj",
    contactMessagePlaceholder: "Descrieți pe scurt motivul pentru care doriți să programați o ședință. Puteți menționa și disponibilitatea dvs.",
    contactPrivacy: "Informațiile tale sunt confidențiale și vor fi folosite doar pentru a te contacta în legătură cu programarea.",
    contactSubmit: "Trimite mesajul",
    contactSubmitting: "Se trimite...",
    contactSuccess: "Mesajul a fost trimis cu succes! Te vom contacta în curând.",
    contactError: "A apărut o eroare. Te rugăm să verifici datele și să încerci din nou.",
    
    // Footer
    footerDesc: "Psiholog clinician și psihoterapeut integrativ. Spațiu sigur pentru autocunoaștere și schimbare.",
    footerLocationTitle: "Locația cabinetului",
    footerAddressLine1: "Strada Petru Rareș 36",
    footerAddressLine2: "Chișinău, Republica Moldova",
    footerLocationNote: "Ședințe online și la cabinet, cu programare prealabilă.",
    footerNav: "Navigare",
    socialConnect: "Conectează-te",
    footerSchedule: "Program",
    footerRights: "Toate drepturile rezervate.",
    footerPrivacy: "Politica de confidențialitate",
    footerTerms: "Termeni și condiții",
    footerCookies: "Politica privind cookie-urile",
    footerCookieSettings: "Setări cookies",
    askAiTitle: "Întreabă AI despre Ruxandra Sterbet",
    askAiText: "Explorează informații publice despre Ruxandra cu ajutorul asistentului AI preferat.",
    askAiAria: "Întreabă {name} despre Ruxandra Sterbet",
    askAiCopied: "Prompt copiat — inserează-l în conversația AI.",
    askAiCopyFailed: "Copiază manual textul de mai jos și inserează-l în conversația AI.",
    askAiPrompt: "Spune-mi despre Ruxandra Sterbet, psiholog clinician și psihoterapeut integrativ. Începe cu https://ruxandrasterbet.com/ și, unde este posibil, verifică și surse publice independente relevante. Rezumă pregătirea profesională, calificările, ariile de activitate, serviciile, limbile de lucru și pentru cine pot fi potrivite serviciile sale. Diferențiază clar informațiile de pe propriul site de cele confirmate din alte surse și menționează eventualele incertitudini sau informații contradictorii.",
    bookingPrivacyNotice: "Programările sunt gestionate prin Calendly. Datele introduse pentru programare și plată pot fi procesate de Calendly și Stripe. Pentru detalii, consultă",
  },
  
  en: {
    // Banner
    bannerText: "Book your first online session with a certified therapist and get",
    bannerDiscount: "–100 RON off",
    bannerCta: "Book now",
    bannerCtaFull: "Book now",
    
    // Navigation
    navAbout: "About me",
    navServices: "Services",
    navTests: "Psychological tests",
    navTestsChildren: "Tests for children and adolescents",
    navTestsAdults: "Tests for adults",
    navBlog: "Blog",
    navBlogArticles: "Articles",
    navBlogResources: "Resources",
    breadcrumbHome: "Home",
    blogEyebrow: "Psychology and psychotherapy",
    blogIntro:
      "Articles and resources in psychology and psychotherapy, offering clear, relevant, and professionally informed information about psychological health, development, and emotional functioning.",
    blogCardArticlesTitle: "Articles",
    blogCardArticlesDesc:
      "Articles about psychology, psychotherapy, psychological health, development, relationships, emotional regulation, and related topics.",
    blogCardArticlesCta: "View articles",
    blogCardResourcesTitle: "Resources",
    blogCardResourcesDesc:
      "Practical psychological materials and resources collected in one accessible space.",
    blogCardResourcesCta: "View resources",
    blogLatestTitle: "Latest articles",
    blogLatestAll: "View all articles",
    blogLatestEmpty:
      "The first articles are being prepared. They will appear here as they are published.",
    articlesArchiveIntro:
      "Articles about psychology, psychotherapy, psychological health, development, relationships and emotional regulation.",
    articlesEmptyTitle: "The first articles are being prepared",
    articlesEmptyText:
      "There are no published articles yet. In the meantime, you can explore the psychoeducational resources available.",
    articlesEmptyCta: "View resources",
    articleReadCta: "Read article",
    navContact: "Contact",
    navCta: "Book an appointment",
    navTagline: "Private Practice in Psychology and Psychotherapy",
    
    // Hero
    heroEyebrow: "Online therapist · Psychological support",
    heroTitleL1: "Understanding the patterns",
    heroTitleL2: "behind",
    heroTitleL3: "how we",
    heroTitleWords: ["think.", "feel.", "relate.", "respond."],
    heroTitleFull: "Understanding the patterns behind how we think, feel, relate, and respond.",
    heroSubtitleA: "Clinical Psychologist and Integrative Psychotherapist. As an online therapist, I offer psychological support and psychotherapy for ",
    heroSubtitleB: "adults, children, and adolescents",
    heroSubtitleC: " in a confidential setting, with a focus on ",
    heroSubtitleD: "understanding individual needs",
    heroSubtitleE: ", strengthening personal resources, and supporting ",
    heroSubtitleF: "more adaptive ways of coping and functioning in everyday life.",
    heroBullet1: "Online sessions in English and Romanian, confidential and individualised",
    heroBullet2: "Evidence-informed psychological practice",
    heroBullet3: "Focused on understanding, coping, and meaningful change",
    heroCta: "Book your first session",
    heroSecondary: "See how I can help",
    heroTransition: "You do not need to have everything figured out to ask for support.",
    heroScroll: "Scroll to explore",
    
    // Validation Section
    validationLabel: "Maybe you recognize yourself here",
    validationTitle1: "Perhaps you recognise",
    validationTitle2: "some of these situations",
    validationSymptom1: "A lot of thoughts",
    validationSymptom2: "Emotional ups and downs",
    validationSymptom3: "Challenges in relationships",
    validationSymptom4: "Feeling drained",
    validationSymptom5: "A desire for change",
    validationCta: "See how I can help",
    validationQuote: '"Therapy is not only for crisis."',
    validationQuoteText: "Many people come to therapy not because something is seriously wrong, but because they want more clarity, emotional balance, and a healthier way of relating to themselves and others.",
    validationFooterNote: "You don't have to figure everything out on your own.",
    perspectiveLabel: "A different perspective",
    perspectiveTitle1: "Therapy is",
    perspectiveTitleItalic: "not only",
    perspectiveTitle2: "for times of crisis.",
    perspectiveP1: "Psychological support can be valuable even when life appears to be functioning relatively well.",
    perspectiveP2a: "Therapy does not have to begin only when difficulties become ",
    perspectiveP2b: "overwhelming",
    perspectiveP2c: "; it can also be a ",
    perspectiveP2d: "proactive way",
    perspectiveP2e: " of understanding emerging concerns, ",
    perspectiveP2f: "strengthening psychological resources",
    perspectiveP2g: ", and addressing patterns ",
    perspectiveP2h: "before they become more persistent or disruptive",
    perspectiveP3: "Sometimes, seeking support early can make change clearer, more manageable, and more sustainable.",
    perspectiveCta: "Learn more about the process",
    perspectiveAside: "Small steps can lead to meaningful change.",
    
    // Services
    servicesLabel: "Services",
    servicesTagline: "Support tailored to your needs.",
    servicesTitle: "Services",
    serviceLearnMore: "Learn more",
    serviceBackToServices: "Back to services",
    svc1Title: "Online Psychotherapy for Adults",
    svc1TitleL1: "Online Psychotherapy",
    svc1TitleL2: "for Adults",
    svc1Meta: "Online · 50 minutes",
    svc1Desc: "Individual psychotherapy for adults experiencing emotional, relational, or personal difficulties who wish to better understand their experiences, reactions, and patterns of functioning, while developing more adaptive ways of managing them.",
    svc1Cta: "Book a session",
    svc2Title: "Counselling for Children and Adolescents",
    svc2Meta: "Online / In-office · 50 minutes",
    svc2Desc: "Psychological support adapted to the developmental stage and individual needs of the child or adolescent, focused on understanding and managing emotional, relational, behavioral, or adjustment difficulties.",
    svc2Cta: "Book a session",
    svc3Title: "Online Career Counselling & Guidance",
    svc3Meta: "Adolescents and young adults · Online / In-office · 50 minutes",
    svc3Desc: "A process of exploring and clarifying interests, abilities, personal values, and educational or professional options, supporting informed decisions about academic and career pathways.",
    svc3Cta: "Book a session",
    svc4Title: "Psychological Assessment",
    svc4Desc: "A psychological assessment process adapted to the individual's age and needs, aimed at understanding cognitive, emotional, behavioral, and adaptive functioning, as well as identifying strengths and areas that may require intervention or support.",
    svc4Cta: "Book an assessment",
    assessChildrenTitle: "Psychological Assessment for Children and Adolescents",
    assessAdultsTitle: "Psychological Assessment for Adults",

    assessAdultsIntro: "Psychological assessment for adults is a structured process in which emotional, cognitive and relational functioning is explored through a clinical interview and validated psychological instruments. The aim is not a label, but a clear understanding of what is happening and of the directions of support that may be appropriate.",
    assessAdultsP2: "The assessment can take place online or in person and is adapted to the question you bring: some situations become clearer in a single meeting, while others require a broader set of instruments administered across two or three sessions.",
    assessAdultsAreasTitle: "What areas can be explored?",
    assessAdultsArea1: "Personality and styles of functioning — stable traits, coping mechanisms and the way you respond to demands.",
    assessAdultsArea2: "Emotional functioning — emotional regulation, sensitivity to stress, and recognising and expressing what you feel.",
    assessAdultsArea3: "Anxiety, mood and stress — the intensity of symptoms, their impact on sleep, concentration and relationships, and signs of occupational burnout.",
    assessAdultsArea4: "Cognitive functioning, when relevant — attention, working memory, processing speed and the organisation of tasks.",
    assessAdultsArea5: "Relational and occupational context — couple, family or team dynamics and adjustment to the work environment.",
    assessAdultsWhyTitle: "Why do adults request a psychological assessment?",
    assessAdultsWhy1: "To understand difficulties that have persisted for some time and are not clarified through informal conversation.",
    assessAdultsWhy2: "To distinguish between situational stress, exhaustion and emotional difficulties that require specialist support.",
    assessAdultsWhy3: "To guide a psychotherapy process and set realistic goals at its beginning.",
    assessAdultsWhy4: "For self-knowledge, personal or professional decisions, and a clearer picture of one's own resources.",
    assessAdultsProcessTitle: "How does the assessment work?",
    assessAdultsProcessText: "We begin with a clinical interview in which we clarify the reason for the psychological evaluation for adults, the relevant history and the current life context. On this basis, suitable instruments are selected — personality questionnaires, clinical scales or cognitive tasks — and we agree together on the number of meetings required. Administration and interpretation follow the professional and ethical standards of psychological practice.",
    assessAdultsFeedbackTitle: "Feedback and recommendations",
    assessAdultsFeedbackText: "At the end you receive a feedback session in which the results are explained in accessible language, without jargon, together with the strengths identified and the difficulties that may require support. Recommendations may include psychotherapy, psychological counselling, a reassessment after a period of time or, where necessary, referral to another specialist. Results are confidential and are shared only with you.",
    assessAdultsNote: "Psychological assessment for adults is a professional process carried out by a psychologist and is different from the free screening tests available on this website, which are indicative only. The clinical and educational assessment offered here does not constitute judicial or medico-legal expertise.",

    assessChildrenIntro: "Psychological assessment for children and adolescents aims to understand how a child functions emotionally, cognitively and behaviourally in relation to their age and developmental stage. The process combines discussion with parents, observation and psychological instruments adapted to the child's age.",
    assessChildrenP2: "Every assessment starts from the family's concrete concern — difficulties at school, intense emotional reactions, problems with attention or relationships — and is built around the child's life context.",
    assessChildrenAreasTitle: "What areas can be explored?",
    assessChildrenArea1: "Emotional functioning — anxiety, fears, sadness, irritability and the ability to recognise and regulate emotions.",
    assessChildrenArea2: "Attention and concentration — sustaining attention on a task, impulsivity, activity level and organisation.",
    assessChildrenArea3: "Learning and school motivation — interest in learning, working pace, specific difficulties and confidence in one's own abilities.",
    assessChildrenArea4: "Behaviour — oppositional behaviour, conflict, anger or withdrawal, and keeping to boundaries.",
    assessChildrenArea5: "School adjustment and relationships — integration in the class group, relationships with teachers and peers, and transitions such as starting school or changing schools.",
    assessChildrenArea6: "Developmental context — developmental milestones, medical history and significant events in the family's life.",
    assessChildrenWhyTitle: "When is a child psychological assessment useful?",
    assessChildrenWhy1: "When difficulties have continued for several weeks and affect school, sleep, relationships or the child's mood.",
    assessChildrenWhy2: "When parents or teachers notice significant changes in behaviour or in school performance.",
    assessChildrenWhy3: "Before educational decisions, such as starting school or choosing a suitable form of support.",
    assessChildrenWhy4: "To establish whether psychological counselling, educational support or an assessment by another specialist is needed.",
    assessChildrenProcessTitle: "How does the assessment work?",
    assessChildrenProcessText: "The process begins with a meeting with the parents, in which we clarify the reason for the psychological evaluation for children, the developmental history and the current situation. This is followed by one or more meetings with the child or adolescent, using age-appropriate instruments and structured activities, and with younger children also play and drawing. With the family's agreement, information may also be requested from the school environment.",
    assessChildrenFeedbackTitle: "Feedback and practical recommendations",
    assessChildrenFeedbackText: "The results are discussed with the parents in a feedback session, in clear language, with an emphasis on the child's strengths and on the difficulties that require support. Recommendations are practical and applicable at home and at school and, where appropriate, include psychological counselling, educational support or referral to another specialist. Adolescents receive feedback adapted to their age, within ethical limits.",
    assessChildrenNote: "Child psychological assessment is a professional process carried out by a psychologist together with the family. It is not an online quiz or an automated test service, and it should not be confused with the free screening tests on this website, which offer general orientation only.",
    assessChildrenTestsIntro: "Free screening tests, indicative only:",
    assessChildrenTest1Anchor: "School adjustment test (ages 6–8)",
    assessChildrenTest2Anchor: "Learning motivation test (ages 8–12)",
    adtHeroDesc: "Online psychotherapy for adults, in English or Romanian. A safe and confidential space where you can openly explore what concerns you, gain a deeper understanding of yourself, feel better, make more aligned choices, build healthier relationships, and find new and more adaptive ways of coping with life's challenges.",

    adtNewTitleL1: "New to therapy?",
    adtNewTitleL2: "You can begin here.",
    adtNewLeft: "Many people choose to start therapy when they feel overwhelmed, stuck or simply want to live a fuller life. A first session is a space to get to know each other, explore what brings you here, and understand how therapy and the context I offer can support you.",
    adtNewRight1: "There is no need to tell your whole story from the start. We can take this slowly, at your pace, asking questions and clarifying step by step what feels important for you right now.",
    adtNewRight2: "You will be listened to with genuine interest, empathy and without judgment, in a professional and confidential setting.",

    adtWorkTitle: "What can online therapy help with?",
    adtWorkIntro: "The topics below are examples, not an exhaustive list. You may bring other concerns that you would like to address:",
    adtConcern1Title: "Anxiety and panic attacks",
    adtConcern1Desc: "Persistent worry, excessive anxiety, panic attacks, and a constant feeling that something bad might happen.",
    adtConcern2Title: "Depression and low mood",
    adtConcern2Desc: "Low energy, loss of interest, feelings of sadness or emptiness on the inside.",
    adtConcern3Title: "Chronic stress and burnout",
    adtConcern3Desc: "Persistent overload, tension, feeling that you can't keep up, and lack of energy.",
    adtConcern4Title: "Trauma and difficult experiences",
    adtConcern4Desc: "Painful events from the past that still affect you in the present.",
    adtConcern5Title: "Relationships and attachment",
    adtConcern5Desc: "Difficulties in relationships, recurring patterns, fear of abandonment or a need for closeness.",
    adtConcern6Title: "Self-esteem and self-criticism",
    adtConcern6Desc: "Lack of confidence, harsh self-criticism, and a negative self-image.",
    adtConcern7Title: "Emotional regulation",
    adtConcern7Desc: "Difficulties in managing intense emotions such as anger, sadness or frustration.",
    adtConcern8Title: "Grief and loss",
    adtConcern8Desc: "The loss of a loved one and adjusting to major changes in life.",
    adtConcern9Title: "Motherhood and postpartum period",
    adtConcern9Desc: "Adjusting to the parenting role, emotional changes and identity after birth.",
    adtConcern10Title: "University studies and academic pressure",
    adtConcern10Desc: "Stress, lack of motivation, perfectionism and difficulties in adapting to university life.",
    adtConcern11Title: "Work and career transitions",
    adtConcern11Desc: "Challenges in the workplace, burnout, career uncertainty and career-related decisions.",
    adtConcern12Title: "Perfectionism and procrastination",
    adtConcern12Desc: "Very high standards, fear of failure, difficulty in starting or completing tasks.",
    adtConcern13Title: "Personal boundaries and communication",
    adtConcern13Desc: "Difficulty saying no, challenging relationships and fear of disappointing others.",
    adtConcern14Title: "Compulsive behaviours and problematic substance use",
    adtConcern14Desc: "Repetitive behaviours that are hard to control and substance use that creates problems in daily life.",
    adtConcern15Title: "Identity and self-understanding",
    adtConcern15Desc: "Questions about meaning, values, direction in life and a deeper understanding of who you are.",

    adtProcessTitle: "How does online psychotherapy work?",
    adtStep1Title: "Initial meeting",
    adtStep1Desc: "We explore together what brings you to therapy and the context in which these difficulties appear.",
    adtStep2Title: "Setting goals",
    adtStep2Desc: "We formulate clear and realistic goals together, based on your needs and available resources.",
    adtStep3Title: "The therapeutic work",
    adtStep3Desc: "We work at your pace, exploring what is important for you, gaining new perspectives and developing tools adapted to your situation.",
    adtStep4Title: "Reviewing progress",
    adtStep4Desc: "We regularly revisit our goals, observe what has changed and adjust the approach as needed, so that therapy remains helpful and meaningful for you.",
    adtCalloutText: "We start from the difficulties you bring, formulate clear and realistic goals together, and adjust along the way based on what we understand about your needs.",

    adtPracticalTitle: "Practical details",
    adtPracticalIntro: "Useful information to help you organize your sessions in the simplest and most comfortable way.",
    adtPracticalCol1Title: "Online worldwide",
    adtPracticalCol1Desc: "Sessions take place online, on a secure video platform, so we can work together wherever you are.",
    adtPracticalCol2Title: "An individual psychotherapy session lasts 50 minutes / €50.",
    adtPracticalCol2Desc: "",
    adtPracticalCol3Title: "10% discount",
    adtPracticalCol3Desc: "Students and people on parental leave are eligible for the discount.",
    adtPracticalCol3Extra: "Reduced fee: €45 per session.",
    adtPracticalCol1Chip1: "Secure platform",
    adtPracticalCol1Chip2: "Worldwide",
    adtPracticalCol2Chip1: "50 minutes",
    adtPracticalCol2Chip2: "€50",
    adtPracticalCol3Chip1: "Students",
    adtPracticalCol3Chip2: "Parental leave",

    adtFaqTitle: "Frequently asked questions",
    adtFaqIntro: "You may find answers to some common questions here. If you have other questions, feel free to contact me.",
    adtFaq1Q: "How do I know if psychotherapy is right for me?",
    adtFaq1A: "If you feel you are facing emotional, relational, or personal difficulties that affect your quality of life, psychotherapy can be a helpful form of support. A first session is a space to explore together whether my approach and the context I offer are a good fit for you.",
    adtFaq2Q: "What happens during a session?",
    adtFaq2A: "A session is a confidential conversation of 50 minutes. We take time to understand what brings you to therapy, explore relevant themes at your pace, and look for new perspectives and tools adapted to your situation.",
    adtFaq3Q: "How long does therapy take?",
    adtFaq3A: "The length of the therapeutic process varies from person to person, depending on your goals and needs. Some themes can be clarified in a few sessions, others require a longer process. We regularly review progress together.",
    adtFaq4Q: "Are sessions confidential?",
    adtFaq4A: "Yes. Everything discussed during sessions is strictly confidential, in accordance with the professional code of psychologists.",
    adtFaq5Q: "Can I have sessions online?",
    adtFaq5A: "Yes. Online sessions take place on a secure platform and are, for most situations, just as effective as in-person sessions.",
    adtFaq6Q: "How do I book a session?",
    adtFaq6A: "You can book a session directly through the booking button, which will take you to my online calendar. If you have questions before scheduling, you can contact me at any time.",

    adtCtaTitle: "You can start with a conversation.",
    adtCtaText: "If now feels like the right time to gain more clarity and balance, I invite you to book a session. We can talk about what you're going through and how therapy can support you.",
    ccaTitleL1: "Psychological Counselling",
    ccaTitleL2: "for Children and Adolescents",
    ccaMeta: "Online / In-person · 50 minutes · €50",
    ccaHeroDesc: "Developmentally appropriate psychological support for children and adolescents, online and in person, in English or Romanian, tailored to their individual needs, strengths, and life context.",
    ccaFormatLabel: "Format",
    ccaFormatValue: "Online / In-person",
    ccaLanguagesLabel: "Languages",
    ccaLanguagesValue: "English · Romanian",
    ccaDurationLabel: "Duration",
    ccaDurationValue: "50 minutes",
    ccaFeeLabel: "Fee",
    ccaFeeValue: "€40–€50",
    ccaWhatTitle: "What is psychological counselling?",
    ccaWhatText1: "A supportive and structured space in which children and adolescents can better understand emotions, relationships, and current difficulties, working with a child psychologist who adapts the process to their age and development.",
    ccaWhatText2: "Depending on age and needs, sessions may include conversation, therapeutic play, drawing, storytelling, emotion-focused activities, and other age-appropriate techniques.",
    ccaProcessTitle: "How does counselling for children and adolescents work?",
    ccaProcess1: "Initial parent consultation",
    ccaProcess2: "Meeting the child or adolescent",
    ccaProcess3: "Ongoing psychological work",
    ccaProcess4: "Parent guidance when appropriate",
    ccaSupportTitle: "When can counselling help a child or teenager?",
    ccaSupport1Title: "Emotional difficulties",
    ccaSupport1Desc: "Anxiety, fears, sadness, low mood.",
    ccaSupport2Title: "School and educational challenges",
    ccaSupport2Desc: "Adjustment, motivation, academic stress.",
    ccaSupport3Title: "Behavioural difficulties",
    ccaSupport3Desc: "Conflicts, impulsivity, oppositional behaviour.",
    ccaSupport4Title: "Life changes and transitions",
    ccaSupport4Desc: "Starting school, family changes, relocation, loss, and more.",
    ccaBookTitle: "Book a session",
    ccaBookText: "Available online and in person · English and Romanian · €50",
    ccaQuestionTitle: "Have a question?",
    ccaQuestionText: "If you are unsure whether counselling is the right fit, you can briefly describe your concerns before scheduling.",
    ccaEmail: "Email",

    vocTitleL1: "Online Career Counselling",
    vocTitleL2: "& Guidance",
    vocAudience: "Adolescents and young adults",
    vocHeroDesc: "Online career counselling for adolescents and adults: a structured process of exploring interests, strengths, personal values, and educational or professional options, designed to support clearer and more informed decisions about academic and career direction.",
    vocFormatLabel: "Format",
    vocFormatValue: "Online / In-person",
    vocLanguagesLabel: "Languages",
    vocLanguagesValue: "English · Romanian",
    vocDurationLabel: "Duration",
    vocDurationValue: "50 minutes",
    vocFeeLabel: "Fee",
    vocFeeValue: "€40–€50",
    vocWhoTitle: "Who can benefit from career counselling?",
    vocWhatTitle: "What is vocational counselling?",
    vocWhatText1: "A structured setting in which interests, aptitudes, and personal values are explored step by step, so that educational and professional options become clearer.",
    vocWhatText2: "The process does not offer ready-made answers; it supports a better understanding of your own profile and more informed decisions, appropriate to your age and life context.",
    vocWhoNote: "You don't have to figure it out alone.",
    vocWho1Title: "Students at key school transitions",
    vocWho1Desc: "For adolescents completing lower secondary school and considering the next educational path.",
    vocWho2Title: "High school students",
    vocWho2Desc: "For young people approaching graduation, university choices, or important academic decisions.",
    vocWho3Title: "Young adults seeking direction",
    vocWho3Desc: "For those who feel uncertain about what to study, what kind of work suits them, or what step to take next.",
    vocWho4Title: "Early career planning",
    vocWho4Desc: "For those preparing for employment, rethinking options, or clarifying professional goals.",
    vocHelpTitle: "How can career guidance help?",
    vocHelpNote: "Greater clarity. More confident choices.",
    vocHelp1Title: "Clarifying interests and strengths",
    vocHelp1Desc: "Explore aptitudes, preferences, and personal resources.",
    vocHelp2Title: "Educational decisions",
    vocHelp2Desc: "Choose between study options, programmes, or academic pathways.",
    vocHelp3Title: "Career direction",
    vocHelp3Desc: "Identify professions and work environments that may be a better fit.",
    vocHelp4Title: "Decision-making and confidence",
    vocHelp4Desc: "Develop clarity, realistic goals, and more confident choices.",
    vocProcessTitle: "How the process works",
    vocProcessNote: "A structured and supportive approach.",
    vocStep1Title: "Initial discussion",
    vocStep1Desc: "We clarify the question, context, and the decision you are facing.",
    vocStep2Title: "Exploring profile",
    vocStep2Desc: "We explore interests, values, strengths, and relevant abilities.",
    vocStep3Title: "Mapping options",
    vocStep3Desc: "We consider suitable educational and professional possibilities.",
    vocStep4Title: "Action plan",
    vocStep4Desc: "We organise next steps for study, applications, or career direction.",
    vocIncludeTitle: "What the process may include",
    vocIncludeNote: "Tailored to your unique situation.",
    vocInc1: "Interests",
    vocInc2: "Values",
    vocInc3: "Aptitudes",
    vocInc4: "Educational pathways",
    vocInc5: "University choices",
    vocInc6: "Work preferences",
    vocInc7: "Goal setting",
    vocInc8: "Decision-making",
    vocInc9: "Motivation",
    vocInc10: "Confidence",
    vocBookTitle: "Book a session",
    vocBookText: "Available online and in person · English and Romanian · 50 minutes · €50",
    vocQuestionTitle: "Have a question?",
    vocQuestionText: "If you are unsure whether vocational counselling is the right fit, you can briefly describe your situation before scheduling.",

    evlTitleL1: "Psychological Assessment",
    evlTitleL2: "and Evaluation",
    evlHeroDesc: "Psychological assessment, sometimes searched for as psychological evaluation, helps clarify emotional, cognitive, behavioural and relational functioning. Assessment is not about labelling or judging, but about clarification, self-knowledge and identifying resources, difficulties and suitable directions of support.",
    evlCta: "Request an assessment",
    evlDisclaimer: "The clinical and educational assessment offered here does not constitute judicial or medico-legal expertise.",
    evlFormatLabel: "Format",
    evlFormatValue: "Online / In-person",
    evlDurationLabel: "Duration",
    evlDurationValue: "15–50 minutes",
    evlFeeLabel: "Fee",
    evlFeeValue: "€20–€50",
    evlConfLabel: "Confidentiality",
    evlConfValue: "Results are shared only with the person assessed; for minors, with the parent or legal guardian, within professional and ethical limits.",
    evlTypesTitle: "Choose the type of assessment",
    evlTypeChildrenTitle: "Psychological Assessment for Children and Adolescents",
    evlTypeChildrenText: "For understanding learning motivation, emotions, behaviour, adjustment and relationships.",
    evlTagC1: "motivation",
    evlTagC2: "emotions",
    evlTagC3: "emotional regulation",
    evlTagC4: "behaviour",
    evlTagC5: "school adjustment",
    evlTagC6: "relationships",
    evlTypeAdultsTitle: "Psychological Assessment for Adults",
    evlTypeAdultsText: "For clarifying personality, stress, burnout, relational difficulties and occupational functioning.",
    evlTagA1: "personality",
    evlTagA2: "stress",
    evlTagA3: "burnout",
    evlTagA4: "relational",
    evlTagA5: "temperament",
    evlTagA6: "occupational",
    evlIncludeTitle: "What may the assessment include?",
    evlIncChildrenCol: "For children and adolescents",
    evlIncAdultsCol: "For adults",
    evlIncC1Title: "Learning motivation",
    evlIncC1Desc: "interest, involvement, school difficulties",
    evlIncC2Title: "Emotions and emotional regulation",
    evlIncC2Desc: "anxiety, sensitivity, emotional expression",
    evlIncC3Title: "Behaviour and adjustment",
    evlIncC3Desc: "impulsivity, oppositional behaviour, adjustment difficulties",
    evlIncC4Title: "Relationships and integration",
    evlIncC4Desc: "peers, family, school climate",
    evlIncC5Title: "Personal resources",
    evlIncC5Desc: "strengths and support needs",
    evlIncA1Title: "Personality",
    evlIncA1Desc: "functioning styles and traits",
    evlIncA2Title: "Stress and burnout",
    evlIncA2Desc: "overload, exhaustion, balance",
    evlIncA3Title: "Relational",
    evlIncA3Desc: "relational dynamics and attachment",
    evlIncA4Title: "Occupational",
    evlIncA4Desc: "professional adjustment and functioning at work",
    evlIncA5Title: "Resources and coping",
    evlIncA5Desc: "coping mechanisms and resilience",
    evlIncNote: "Instruments are selected according to the purpose of the assessment, age and the particularities of each situation.",
    evlProcessTitle: "How does the process work?",
    evlStep1Title: "Clarifying the request",
    evlStep1Desc: "We define the aim of the assessment and the questions we want to answer.",
    evlStep2Title: "Choosing the instruments",
    evlStep2Desc: "Suitable methods are selected according to age and purpose.",
    evlStep3Title: "Administration and interpretation",
    evlStep3Desc: "Applying the instruments and integrated analysis of the results.",
    evlStep4Title: "Feedback and recommendations",
    evlStep4Desc: "You receive clear conclusions and practical directions for intervention or support.",
    evlImportantTitle: "What is important to know",
    evlImp1Title: "It is not a label",
    evlImp1Text: "The purpose of assessment is understanding, not judgement or reducing a person to a score.",
    evlImp2Title: "A confidential process",
    evlImp2Text: "Results are discussed in a confidential setting and shared only with the person assessed or, for minors, with the parent / legal guardian.",
    evlImp3Title: "Flexible duration and cost",
    evlImp3Text: "Duration and cost depend on the aim of the assessment, the instruments used and the complexity of the case.",

    questionHeading: "Have a question before booking?",
    questionText: "If you need clarification about availability, session format, or the first appointment, you can contact me directly.",
    questionWhatsapp: "WhatsApp",
    servicesTitleOld: "Not all types of psychological help are the same",
    servicesSubtitle: "Many people don't know exactly what suits them. Here you'll find the simple difference.",
    serviceRecommended: "Recommended",
    serviceDuration: "Duration:",
    serviceSuitable: "Suitable if:",
    
    service1Title: "Integrative Psychotherapy",
    service1Price: "700 RON",
    service1Duration: "medium-long",
    service1Desc: "In-depth process oriented towards stable changes.",
    service1Point1: "Anxiety keeps returning",
    service1Point2: "You have repetitive relational patterns",
    service1Point3: "You want to understand why you react the way you do",
    service1Point4: "You want real change, not just quick fixes",
    
    service2Title: "Psychological Counseling",
    service2Price: "600 RON",
    service2Duration: "short",
    service2Desc: "Focused intervention on a concrete situation.",
    service2Point1: "You need to make a decision",
    service2Point2: "You have a specific blockage",
    service2Point3: "You need clear guidance",
    service2Point4: "You want quick structure",
    
    service3Title: "Personal Development",
    service3Price: "600 RON",
    service3Duration: "variable",
    service3Desc: "Functioning optimization and self-knowledge.",
    service3Point1: "You don't have a major problem but want clarity",
    service3Point2: "You want to improve your relationships",
    service3Point3: "You want to understand your emotions",
    service3Point4: "You want more stable personal performance",
    
    servicesNote: "If you're not sure what suits you,",
    servicesNoteHighlight: "we'll choose together in the first session.",
    
    // Issues
    issuesLabel: "Issues addressed",
    issuesTitle: "How I can help you",
    issue1: "Anxiety",
    issue2: "Burnout",
    issue3: "Depression",
    issue4: "Stress",
    issue5: "Self-esteem",
    issue6: "Relationships",
    issue7: "Emotional regulation",
    issue8: "Procrastination",
    issue9: "High sensitivity",
    issue10: "Educational difficulties",
    issue11: "Self-knowledge",
    
    // How It Works
    howLabel: "The therapeutic process",
    howTitle: "How therapy works",
    howStep1Title: "First meeting",
    howStep1Desc: "We clarify what's happening and establish the right direction for you.",
    howStep2Title: "Identify patterns",
    howStep2Desc: "We explore together what lies at the root of your current difficulties.",
    howStep3Title: "Interventions and exercises",
    howStep3Desc: "We apply techniques and exercises adapted to your specific needs.",
    howStep4Title: "Build autonomy",
    howStep4Desc: "You develop your own resources to function independently.",
    howNote: "Change rarely happens all at once. It becomes visible gradually—in what you understand, choose, and do differently.",
    
    // About
    aboutLabel: "About me",
    aboutName: "Ruxandra Sterbet",
    aboutTitle: "Clinical psychologist · Psychotherapist trained in integrative psychotherapy",
    aboutSubtitle: "PhD candidate in psychology · University teaching assistant · Educational counsellor",
    aboutExperience: "5 years of experience providing psychological and psychotherapeutic support to children, adolescents, and adults",
    aboutReadMore: "Learn more about my background",
    aboutGetInTouch: "Get in touch",
    aboutCredentials1: "Clinical Psychologist · Psychotherapist trained in Integrative Psychotherapy · Educational Counsellor",
    aboutCredentials2: "PhD Candidate in Psychology · Researcher · University Teaching Assistant",
    aboutPara1: "I am a clinical psychologist and psychotherapist trained in integrative psychotherapy, with experience working with children, adolescents, and adults. My professional activity brings together psychotherapeutic practice, psychological and educational counselling, psychological assessment, academic teaching, and research.",
    aboutPara2: "In my work, I take an individualised and integrative approach, considering the emotional, cognitive, relational, and contextual factors that shape each person's experience and current difficulties. I aim to offer a safe, collaborative, and professionally grounded space in which meaningful psychological change can take place.",
    aboutPara3: "Alongside clinical practice, I am involved in university teaching and doctoral research in psychology, with a particular focus on learning motivation and emotional well-being in children in the context of digitalisation.",
    homeAboutLangNote: "I work mainly online, as a Romanian-speaking therapist offering sessions in English and Romanian, and in person at my office in Chișinău.",
    aboutHl1Title: "Clinical practice",
    aboutHl1Desc: "5+ years of experience working with children, adolescents, and adults",
    aboutHl2Title: "Educational counselling",
    aboutHl2Desc: "Support for school adjustment, socio-emotional development, and educational guidance.",
    aboutHl3Title: "Academic and research work",
    aboutHl3Desc: "Bridging psychological research, academic teaching, and applied practice.",
    aboutHl4Title: "Integrative approach",
    aboutHl4Desc: "Evidence-informed, flexible, and tailored to your individual needs",
    aboutFullTitle: "About me",
    aboutFullBack: "Back to home page",
    aboutFullPlaceholder: "The full text for this page will be added soon.",
    aboutYears: "years experience",
    
    // Pricing
    pricingLabel: "Investment",
    pricingTitle: "Pricing",
    pricingSession: "Session: 50 minutes",
    pricingDesc1: "Deep process oriented towards lasting changes",
    pricingDesc2: "Short intervention for concrete situations",
    pricingDesc3: "Self-knowledge and personal optimization",
    pricingPackages: "Psychotherapy Packages",
    pricingPkg1: "4 sessions/month",
    pricingPkg2: "3 sessions/month",
    pricingPkg3: "2 sessions/month",
    pricingPerSession: "/ session",
    pricingCancel: "Cancellation or rescheduling: minimum 24h in advance",
    pricingCta: "Book",
    
    // Booking
    bookingEyebrow: "Take the next step",
    bookingTitle: "Book a session",
    bookingDesc: "The first meeting lasts 50 minutes and helps you clearly understand what you need and how we can work together.",
    bookingAvailability: "Availability",
    bookingFormatTitle: "Online / In-person",
    bookingFormatDesc: "Sessions are available online or in person at the psychology and psychotherapy practice.",
    bookingMapsLink: "View location on Google Maps →",
    bookingMapsAria: "View Ruxandra Sterbet psychology and psychotherapy practice on Google Maps",
    bookingDurationTitle: "Session duration",
    bookingDurationValue: "50 minutes",
    bookingCardTitle: "Book your session",
    bookingCardDesc: "Choose the format that works best for you (online or in-person).",
    bookingSchedule: "Schedule",
    bookingWeekdays: "Monday – Friday: 3:00 PM – 7:00 PM",
    bookingWeekend: "Weekend: 10:00 AM – 3:00 PM",
    bookingMethods: "Contact methods",
    bookingWhatsapp: "WhatsApp",
    bookingForm: "Contact form",
    bookingPromoTitle: "First session with discount!",
    bookingPromoText: "Use the code",
    bookingPromoCode: "THERAPY100",
    bookingPromoDiscount: "for 100 RON discount on your first booking.",
    bookingOnline: "Online Sessions",
    bookingOnlineDesc: "All sessions are conducted online via video conference, providing you with the comfort and privacy you need.",
    bookingFormCta: "Fill out the form",
    bookingCalendly: "Online calendar (Calendly)",
    bookingCalendlyCta: "Book in calendar",
    
    // Articles
    articlesLabel: "Resources",
    articlesTitle: "Articles and resources",
    articlesSubtitle: "Useful content for understanding and personal development",
    articleCat1: "Therapeutic topics",
    articleCat2: "Orientation tests",
    articleCat3: "About therapy",
    articleCat4: "Mental health",
    articleCat5: "Book & film recommendations",
    articlesNote: "Articles will be available soon.",
    
    // Psychological Tests
    testsLabel: "Psychological tests",
    testsTitle: "Psychological orientation tests",
    testsSubtitle: "Discover resources and orientation tests that can help you better understand how you feel.",
    testsNote: "Psychological tests will be available soon.",
    testsAdultsAssessmentIntro: "For a professional process carried out by a psychologist, see",
    testsAdultsAssessmentAnchor: "psychological assessment for adults",
    testsChildrenTitle: "Psychological tests for children and adolescents",
    testsChildrenSubtitle: "Psychological assessment tools for exploring the cognitive, emotional, behavioral, relational, academic, and social functioning of children and adolescents.",
    assessSvcHeading: "Psychological assessments",
    assessSvcIntro: "Individual psychological assessment services, tailored to the child's age, developmental profile, and the reason for seeking support.",
    assessSvcCta: "Learn more",
    assessSvc1Title: "School readiness and adjustment in first grade",
    assessSvc1Desc: "Assessment for preschool children and first-grade pupils, focused on understanding readiness for the start of schooling and adjustment to the demands of the educational environment.",
    assessSvc2Title: "Assessment service 2 (title to be added)",
    assessSvc2Desc: "The description of this psychological assessment service will be added later. The card structure stays consistent with the other services in this section.",
    assessSvc3Title: "Assessment service 3 (title to be added)",
    assessSvc3Desc: "The description of this psychological assessment service will be added later. The card structure stays consistent with the other services in this section.",
    assessSvc4Title: "Assessment service 4 (title to be added)",
    assessSvc4Desc: "The description of this psychological assessment service will be added later. The card structure stays consistent with the other services in this section.",
    assessSvc5Title: "Assessment service 5 (title to be added)",
    assessSvc5Desc: "The description of this psychological assessment service will be added later. The card structure stays consistent with the other services in this section.",
    testsFreeHeading: "Free tests",
    testsFreeIntro: "Complete one of the available tests and receive an indicative result by email, together with a brief explanation of your score.",
    testsFreeDisclaimer: "The free tests are intended for screening and guidance only and do not replace an individual psychological assessment.",
    testsCardFree: "Take the test for free",
    evlCtaAssessChildren: "Psychological assessment for children and adolescents",
    evlCtaAssessAdults: "Psychological assessment for adults",
    testSchoolAdjustmentName: "School Adjustment",
    testSchoolAdjustmentAnchor: "School adjustment test",
    testLearningMotivationAnchor: "Learning motivation test",
    testSchoolAdjustmentAge: "Ages 6–8",
    testSchoolAdjustmentTime: "10 minutes",
    testLearningMotivationName: "Learning Motivation",
    testLearningMotivationAge: "Ages 8–12",
    testLearningMotivationTime: "10 minutes",
    testRunnerBack: "Back to tests",
    testRunnerSoonTitle: "This test will be available soon",
    testRunnerSoonText: "The questions and the interpretation are being prepared. Once the test is live, you will be able to complete it right here and enter your email address at the end to receive your indicative result.",
    testRunnerEmailNote: "Sending results by email is not active yet. It will be enabled once the test is published.",
    testsAdultsTitle: "Psychological tests for adults",
    testsAdultsSubtitle: "A selection of orientation tests for adults that can help you clarify what you feel before talking to a specialist.",
    testsBack: "Back to home page",
    testsCardAction: "Start the test",
    testsCardActionSoon: "Coming soon",
    testsAgeLabel: "Age",
    testsPlaceholderName: "Test coming soon",
    testsPlaceholderDesc: "A short description of the test will be added here.",
    testsPlaceholderAge: "—",
    testsComingSoon: "Tests will be added soon.",

    // FAQ
    faqLabel: "Frequently asked questions",
    faqTitle: "Have questions?",
    faqQ1: "Who do you work with?",
    faqA1: "I work with children aged 7 and above, adolescents, and adults, tailoring psychological support to each person’s needs, experiences, and stage of life. I offer online sessions for people from different countries, cultural backgrounds, and walks of life. Sessions take place in a confidential, respectful setting, where you can openly explore your thoughts, emotions, and challenges, with sensitivity to your cultural context and personal values.",
    faqQ2: "Are sessions available online or in person?",
    faqA2: "Both options are available.\n\nOnline sessions are available internationally and are conducted via secure video consultation. As a Romanian-speaking therapist working online, I see clients in English and in Romanian.\n\nIn-person sessions are currently available in Chisinau, Republic of Moldova.\n\nYou can choose the format that is most suitable for your circumstances and preferences.",
    faqQ3: "How long does a session last?",
    faqA3: "Psychotherapy, psychological counselling, and career counselling sessions generally last 50 minutes.\n\nPsychological assessment and psychodiagnosis do not always follow the same timeframe. The duration depends on the purpose of the assessment, the psychological instruments used, and the complexity of the evaluation process. Some assessments may therefore require more than one meeting.",
    faqQ4: "How much does a session cost?",
    faqA4: "Fees vary depending on the service you need. For details about the services offered, session duration and corresponding fees, please consult the “Services” section above.",
    faqQ5: "Does a psychotherapist prescribe medication?",
    faqA5: "No. Psychotherapists and psychologists do not prescribe medication.\n\nMedication can be prescribed by a medical doctor, such as a psychiatrist. When appropriate, psychological or psychotherapeutic work can take place alongside psychiatric treatment, and a psychiatric consultation may be recommended when additional medical evaluation would be beneficial.",
    faqQ6: "What happens during the first session?",
    faqA6: "The first meeting is an opportunity to understand what brings you to therapy, explore your current concerns and expectations, and clarify what kind of psychological support may be most appropriate.\n\nYou do not need to arrive with a perfectly defined problem or therapy goal. These can be clarified together as the process develops.",
    faqQ7: "How many sessions will I need?",
    faqA7: "There is no predetermined number of sessions that applies to everyone.\n\nThe duration of the process depends on the nature of the difficulties, therapeutic goals, individual needs, and progress over time. Some people seek support for a specific issue over a shorter period, while others choose a longer therapeutic process.\n\nThe need and direction of therapy are reviewed collaboratively throughout the work.",
    
    // Testimonials
    testimonialLabel: "Experiences",
    testimonialTitle: "Why people choose therapy",
    testimonialQuote: '"People who started therapy didn\'t come because they "had time," but because they needed clarity."',
    testimonialText: "Their experiences are different, but they have one thing in common:",
    testimonialHighlight: "they understood better what was happening to them.",
    
    // Contact Form
    contactLabel: "Contact",
    contactTitle: "Send a message",
    contactSubtitle: "Fill out the form below and I will contact you as soon as possible.",
    contactName: "Full name",
    contactNamePlaceholder: "Enter your full name",
    contactEmail: "Email",
    contactEmailPlaceholder: "email@example.com",
    contactPhone: "Phone",
    contactPhonePlaceholder: "+373 XX XXX XXX",
    contactSessionType: "Preferred session type",
    contactOnline: "Online – Video conference",
    contactCabinet: "Office – Chișinău",
    contactSubject: "Subject",
    contactSubjectPlaceholder: "e.g., First session booking",
    contactMessage: "Message",
    contactMessagePlaceholder: "Briefly describe the reason you want to book a session. You can also mention your availability.",
    contactPrivacy: "Your information is confidential and will only be used to contact you regarding your booking.",
    contactSubmit: "Send message",
    contactSubmitting: "Sending...",
    contactSuccess: "Message sent successfully! We will contact you soon.",
    contactError: "An error occurred. Please check your data and try again.",
    
    // Footer
    footerDesc: "Clinical psychologist and integrative psychotherapist. A safe space for self-knowledge and change.",
    footerLocationTitle: "Practice location",
    footerAddressLine1: "Strada Petru Rareș 36",
    footerAddressLine2: "Chișinău, Republic of Moldova",
    footerLocationNote: "Online and in-person sessions available by appointment.",
    footerNav: "Navigation",
    socialConnect: "Connect",
    footerSchedule: "Schedule",
    footerRights: "All rights reserved.",
    footerPrivacy: "Privacy Policy",
    footerTerms: "Terms of Use",
    footerCookies: "Cookie Policy",
    footerCookieSettings: "Cookie settings",
    askAiTitle: "Ask AI about Ruxandra Sterbet",
    askAiText: "Explore publicly available information about Ruxandra through your preferred AI assistant.",
    askAiAria: "Ask {name} about Ruxandra Sterbet",
    askAiCopied: "Prompt copied — paste it into the AI chat.",
    askAiCopyFailed: "Copy the text below manually and paste it into the AI chat.",
    askAiPrompt: "Tell me about Ruxandra Sterbet, clinical psychologist and integrative psychotherapist. Start with https://ruxandrasterbet.com/ and, where possible, check relevant independent public sources. Summarize her professional background, qualifications, areas of practice, services, languages, and who her services may be suitable for. Clearly distinguish information from her own website from information confirmed elsewhere, and note any uncertainty or conflicting information.",
    bookingPrivacyNotice: "Appointments are managed through Calendly. Information entered for booking and payment may be processed by Calendly and Stripe. See the",
  }
};
